/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import OverlayFactory from 'comps/OverlayFactory';
import { Tooltip } from 'react-bootstrap';
import commands from './commands';
import cx from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import MetricsContext from './MetricsContext';

const TooltipWrapper = OverlayFactory(Tooltip);

type PropsT = {
  id: string,
  index: number,
  name: string,
  description: string,
  custom: boolean,
};

export default (props: PropsT): Node => {
  const ctx = useContext(MetricsContext);
  const isActive = ctx.state.selectedMetrics.includes(props.id);
  const id = props.id || String(props.index);

  return (
    <Draggable draggableId={id} index={props.index}>
      {(provided, snapshot) => {
        let { style } = provided.draggableProps;
        if (style) {
          let { transform } = style;
          if (transform && snapshot.isDragging) {
            transform = `${transform} rotate(2deg)`;
            style = { ...style, transform };
          }
        }

        const IconButton = (v) => {
          return (
            <div
              css={css(`
                    font-size: 1rem;
                    button { color: #333; }
                    margin-right: ${v.marginRight};
                  `)}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  v.onClick();
                }}
              >
                <TooltipWrapper
                  placement="left"
                  content={v.tooltip}
                  id={`${v.tooltip}-field`}
                >
                  {v.children}
                </TooltipWrapper>
              </button>
            </div>
          );
        };

        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={style || {}}
            css={css(`
              padding: 5px 10px;
              border-bottom: solid 1px #efefef;
              cursor: pointer;
              display: grid;
              grid-template-columns: 20px 1fr;
              scroll-snap-align: start;
              position: relative;
              background: white;
              ${
                snapshot.isDragging
                  ? `
                border: solid 1px #ccc;
                box-shadow: 1px 1px 5px #ccc;
              `
                  : ''
              }
          `)}
            onClick={() => {
              commands(ctx).toggleSelected(props.id);
            }}
          >
            <div>
              <i
                className={cx('fa-circle', { far: !isActive, fa: isActive })}
                css={css('font-size: 1rem;')}
              />
            </div>
            <div>
              <div>{props.name} </div>
              <div
                css={css(`
                  font-size: 1rem;
                `)}
              >
                {props.description}{' '}
              </div>
              {props.custom && (
                <div className="d-flex float-right">
                  <IconButton
                    marginRight="0px"
                    tooltip="Edit"
                    onClick={() => {
                      commands(ctx).editWidget(props.id);
                    }}
                  >
                    <i className="fa fa-edit" />
                  </IconButton>
                  <IconButton
                    marginRight="18px"
                    tooltip="Delete"
                    onClick={() => {
                      commands(ctx).deleteWidget(props.id);
                    }}
                  >
                    <i className="fa fa-trash" />
                  </IconButton>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};
